import { useOrderQuery } from '@entities/payment'
import {
  PaymentCtaSection,
  ProductSummarySection,
  TossWidgetSection,
  useTossPayment,
} from '@features/payment'
import {
  TossStatusGate,
  TossWidgetError,
  TossWidgetLoading,
} from '@features/payment/ui/toss-widget-section'

import { PosthogPageView } from '@shared/lib/posthog'
import { getTossPayments } from '@shared/lib/toss-payments'
import { AppHeader } from '@shared/ui/app-header'
import { LoadingScreen } from '@shared/ui/loading-screen'
import { NoSsrSuspense } from '@shared/ui/no-ssr-suspense'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/payment')({
  validateSearch: (search: Record<string, unknown>) => {
    const orderId = search.orderId
    if (typeof orderId !== 'string' || orderId.length === 0) {
      throw new Error('결제에 필요한 정보가 없어요. 사주 풀이를 먼저 진행해 주세요.')
    }
    return { orderId }
  },
  loader: () => {
    getTossPayments()
  },
  component: () => (
    <PosthogPageView event="view_payment">
      <NoSsrSuspense fallback={<LoadingScreen />}>
        <PaymentPage />
      </NoSsrSuspense>
    </PosthogPageView>
  ),
  ssr: false,
})

function PaymentPage() {
  const { orderId } = Route.useSearch()
  const { data: order } = useOrderQuery(orderId)

  const payment = useTossPayment({
    orderId: order.orderId,
    orderName: order.orderName,
    amount: order.amount,
  })

  return (
    <>
      <AppHeader leading={<AppHeader.Back />} title="결제하기" variant="blur" divider="elevation" />

      <div className="bg-bg-base flex-1 pb-content-bottom pt-6">
        <ProductSummarySection
          className="px-page-x"
          orderName={order.orderName}
          amount={order.amount}
        />
        <TossStatusGate
          status={payment.effectiveStatus}
          loadingElement={<TossWidgetLoading />}
          errorElement={<TossWidgetError onRetry={payment.retryInit} />}
          className="mt-6"
        >
          <TossWidgetSection />
        </TossStatusGate>
      </div>

      <PaymentCtaSection
        amount={order.amount}
        agreed={payment.agreed}
        onToggleAgreed={payment.toggleAgreed}
        canPay={payment.canPay}
        isPayLoading={payment.isLoading || payment.isPaying}
        onPayment={payment.handlePayment}
      />
    </>
  )
}
